import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoutingComponent } from './component/routing.component';
import {  ServiceResponseModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { TransportInfoPanelModule } from '@sdbn/common';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { RoutingPositionEditorComponent } from './component/routing-position-editor/routing-position-editor.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [RoutingComponent, RoutingPositionEditorComponent],
  imports: [
    CommonModule,

    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TransportInfoPanelModule,
    CommonTranslationModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonUIModule,
    DragDropModule,
    MatInputModule,
    MatCheckboxModule
  ],
  exports: []
})
export class TransportRoutingModule { }
